import { DialogClose, useDialogClose } from "@suse-o11y/dialog";
import { useMutation } from "@suse-o11y/query";
import React from "react";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../../common/openapi";
import { deleteSilencingRule } from "../../../../../../../queries/silencing-rules";
import { useUnmuteDrawerContext } from "../context";

export function UnmuteFooter({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	const { onDelete } = useUnmuteDrawerContext();
	const close = useDialogClose();

	const { mutate: unmuteMonitor, isLoading } = useMutation({
		onSuccess: () => {
			onDelete();
			close();
		},
		...deleteSilencingRule,
	});

	return (
		<footer className="drawer-footer">
			<DialogClose className="button button-tertiary uppercase">Close</DialogClose>
			<button
				aria-busy={isLoading}
				className="button button-primary uppercase"
				onClick={() => {
					if (!isLoading) {
						unmuteMonitor(rule.identifier);
					}
				}}
				type="button"
			>
				Unmute monitor
			</button>
		</footer>
	);
}
